module.exports = __webpack_public_path__ + "static/8-polar-bear-star-50cd16daae0c12a96621fdfd219e1abe.png";